import React from 'react';

import { TableCell, TableHead, TableRow } from '@mui/material';

export default function DealOptionsTableHeader() {
  return (
    <TableHead>
      <TableRow
        sx={{
          '& .MuiTableCell-head': {
            bgcolor: 'grey.50',
            color: 'text.secondary',
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 0,
            textTransform: 'uppercase',
          },
        }}
      >
        <TableCell sx={{ width: 48 }} />
        <TableCell>Deal Option Name</TableCell>
        <TableCell align="center" sx={{ width: 120 }}>
          Allocation
        </TableCell>
        <TableCell align="center" sx={{ width: 140 }}>
          Max Extra Nights
        </TableCell>
        <TableCell align="right" sx={{ width: 180 }}>
          Cost
        </TableCell>
        <TableCell align="right" sx={{ width: 140 }}>
          Sell price
        </TableCell>
        <TableCell align="right" sx={{ width: 140 }}>
          Cost/Night
        </TableCell>
        <TableCell align="right" sx={{ width: 120 }}>
          Margin
        </TableCell>
      </TableRow>
    </TableHead>
  );
}
